import React, { useState, useEffect } from 'react';
import { useMessages } from './MessageContext';
import { useTranslation } from 'react-i18next';

const MessageItem = ({ message }) => {
  const { t } = useTranslation('common');
  const { removeMessage } = useMessages();
  const [isVisible, setIsVisible] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);


  useEffect(() => {
    // Trigger entry animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsRemoving(true);
    setTimeout(() => {
      removeMessage(message.id);
    }, 300); // Match CSS transition duration
  };

  const getIcon = () => {
    switch (message.type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '●';
    }
  };

  return (
    <div
      className={`message-item message-${message.type} ${isVisible ? 'message-visible' : ''} ${isRemoving ? 'message-removing' : ''}`}
      onClick={handleClose}
    >
      <div className="message-icon">
        {getIcon()}
      </div>
      <div className="message-content" style={{
        color: '#ffffff',
        display: 'block',
        visibility: 'visible',
        opacity: '1',
        zIndex: '10000'
      }}>
        <div className="message-title" style={{
          color: '#ffffff !important',
          fontWeight: '700',
          fontSize: '15px',
          display: 'block',
          visibility: 'visible',
          opacity: '1',
          textShadow: 'none',
          background: 'rgba(0,0,0,0.3)',
          padding: '2px 4px',
          borderRadius: '2px'
        }}>{message.title}</div>
        <div className="message-text" style={{
          color: '#ffffff !important',
          fontSize: '13px',
          display: 'block',
          visibility: 'visible',
          opacity: '1',
          textShadow: 'none',
          background: 'rgba(0,0,0,0.3)',
          padding: '2px 4px',
          borderRadius: '2px',
          marginTop: '4px'
        }}>{message.message}</div>
      </div>
      <button
        className="message-close"
        onClick={(e) => {
          e.stopPropagation();
          handleClose();
        }}
        aria-label={t('messages.closeMessage')}
      >
        ✕
      </button>
    </div>
  );
};

export default MessageItem;